import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/energy/energy2.webp";
import image1 from "../../../images/energy/energy3.webp";
import image2 from "../../../images/energy/energy4.webp";
import image3 from "../../../images/energy/energy5.webp";

const EnergyUtilities = () => {
  const banner = {
    title: "Energy & Utilities",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Digital Energy",
      description:
        "The digital energy market is becoming even more complex and challenging with energy and utility companies facing a level of disruption not seen in decades with new cash rich competitors entering the energy and utilities arena.",
      tagName: "Learn More",
      tagLink: "digitalenergy",
    },
    {
      image: image2,
      title: "Digital Utility",
      description:
        "The Utility landscape as of now has entered a new era of change and uncertainty.  Security threats are growing, regulations are tightening and the emergence of new technologies from smart meters to micro grids is disrupting the long-standing business models.",
      tagName: "Learn More",
      tagLink: "digital-utility",
    },
    {
      image: image3,
      title: "Electrical & Gas Utilities",
      description:
        "Digital transformation is affecting many markets and Electricity & Gas Utility sector is not an exception. Mature companies are losing market share to competitive brands that are offering superior digital systems, innovative sales strategies and agile operating structures. As such, electricity and Gas Utility service providers need to adapt to disruption while at the same time provide safe and reliable services.",
      tagName: "Learn More",
      tagLink: "electricityandgasservices",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Energy & Utilities — Cylon Technologies – Big Data | Data Analytics |
          Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content pb-5">
        <div className="container">
          <h2 className="heading2 text-center pb-4">Energy & Utilities</h2>
          <p>
            Cylon Technologies is your partner in implementing digital energy
            solutions for the smart digitalization of your energy supply and in
            implementing applicable solutions when it comes to the question of
            how to integrate the energy sectors of electricity, heat and
            mobility thereby helping you in developing long-terms strategies for
            an interaction between demand and supply.{" "}
          </p>
          <p>
            Cylon Technologies offers energy solutions from a variety of sources
            and combines intelligent software and IT systems with individually
            tailored hardware offerings across the sectors of electricity, heat
            and mobility for different consumer groups.{" "}
          </p>
          <p>
            At Cylon Technologies, digital transformation is not just a concept
            but involves real world solutions for real world results. A customer
            mindset is at the foundation of what we do and you can place trust
            on our digital energy solutions team that is highly skilled and
            deeply committed to your success and in working together with you in
            every step of the way.
          </p>
          <div className="col-md-10 mx-auto">
            <div className="row g-md-5 g-4">
              {card.map((item, index) => (
                <div className="col-md-6" key={index}>
                  <div className="img_card">
                    <img src={item.image} alt="images" />
                    <h2 className="heading2">{item.title}</h2>
                    <p>{item.description}</p>

                    {/* Conditionally render link button if both tagName and tagLink exist */}
                    {item.tagName && item.tagLink && (
                      <div className="btn_spacet">
                        <a
                          href={item.tagLink}
                          className="btn_small outline_blue"
                        >
                          {item.tagName}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center pt-5">
              <Link
                to="/connect"
                className="btn_custom blue_btn"
                href="Inquire"
              >
                Inquire
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EnergyUtilities;
